module.exports = __webpack_public_path__ + "static/media/file_remarks_description_report_Selected.473b2835.svg";